import LazyVideo from '@cartwhl/ui/atoms/LazyVideo';

import { CDN } from 'consts';

export default function VideoSection() {
  return (
    <section className="pb-(--vertical-spacing)">
      <div className="md:container">
        <div className="bg-gray-15 relative aspect-video flex-1 overflow-hidden p-8 md:rounded-2xl">
          <LazyVideo
            src={`${CDN}v2_data_01_data_hero.webm`}
            className="absolute inset-0 h-full w-full rounded-[inherit]"
            mode="autoplay"
          />
        </div>
      </div>
    </section>
  );
}
